module.exports = __webpack_public_path__ + "img/player_hint_arrow.7eccf79e.png";